import React, { Component, createRef } from "react"
import cx from 'classnames'
import { Layout, Container, NavBottom } from 'src/components/Layout'
import { injectIntl } from 'react-intl'
import { isNavBottomVisible } from 'src/utils/features'
import List from 'src/components/List'
import NotificationBanner from "src/components/NotificationBanner"
import Footnote from 'src/components/Footnote'
import { getCurrentPageUrlInfo, getKioskDocument } from 'src/utils/helpers'

// TODO: Convert to modular CSS
import "./Sidebar.less"
import styles from "./Sidebar.module.less"

class Sidebar extends Component {

  render() {
    const {
      isSidebarVisible,
      location,
      isChatOnlyFeature,
      featuresAndOptions,
      features,
      chatOptions,
      isAfterHours,
      isChatEmpty,
      areAppActionsDisabled,
      bannerNotification,
      notificationHeight,
      isNotificationHidden
    } = this.props



    // Append right icon to each feature
    const mainMenuItems = featuresAndOptions.map(feature => {
      return {
        ...feature,
        rightIcon: 'right',
      }
    })

    const currentPageUrl = getCurrentPageUrlInfo(location, 'url')

    const isChatPage = currentPageUrl === '/chat'

    const classNames = cx({
      [styles.hideOnMobile]: isSidebarVisible === false || isChatPage,
      'c-layout-sidebar': true,
    })

    const withBottomNavCls = isNavBottomVisible(
      features,
      chatOptions,
      isAfterHours,
      isChatEmpty,
      isChatOnlyFeature
    ) ? ' with-bottom-nav' : ''

    const containerStyleWithNotification = isNotificationHidden || getKioskDocument().body.clientWidth > 990 ? {} : {
      height: `calc(100% - 76px - 20px * 2 - ${notificationHeight}px)`,
      marginTop: `calc(76px + 20px * 2 + ${notificationHeight}px)`
    } 

    return ( 
      <Layout.Sider className={classNames}>
        <NotificationBanner
          className={styles.displayingNotification}
          bannerNotification={bannerNotification}
        />
        <Container className={"sidebar-container" + withBottomNavCls} style={containerStyleWithNotification}>
          <List
            items={mainMenuItems}
            isMainMenu={true}
            preventActiveState={isChatPage}
            areAppActionsDisabled={areAppActionsDisabled}
            attrDataQa="list-main-menu"
          />
          <div className={styles.fillOutSpace} />
          <Footnote location="sidebar" />
          <NavBottom />
        </Container>
      </Layout.Sider>
    )
  }
}

export default injectIntl(Sidebar);
